/* eslint-disable no-underscore-dangle */
import { MenuItem } from '../app-base/services/menu.service';
import { MenuCallback } from './models/menu.model';
import { RootModuleType } from './models/root-module.model';
import { CMS_BASE_PATH, CM_BASE_PATH } from './shared/app.const';

export enum MenuType {
  CLIENTS = 'CLIENTS',
  COMPANY = 'COMPANY',
  PERSONNEL = 'PERSONNEL',
  CONTACTS = 'CONTACTS',
  CLIENT_DOCUMENTS = 'CLIENT_DOCUMENTS',
  CLIENT_REPORTS = 'CLIENT_REPORTS',
  CONTRACTS_AND_RENEWALS = 'CONTRACTS_AND_RENEWALS',
  INVOICES = 'INVOICES',
  INVOICES_PROCESS_INVOICES = 'INVOICES_PROCESS_INVOICES',
  INVOICES_INVOICES_TO_PULL = 'INVOICES_INVOICES_TO_PULL',
  INVOICES_CREDIT_INVOICES = 'INVOICES_CREDIT_INVOICES',
  INVOICES_INVOICE_STATUS = 'INVOICES_INVOICE_STATUS',
  STATEMENTS = 'STATEMENTS',
  STATEMENTS_PROCESS_STATEMENTS = 'STATEMENTS_PROCESS_STATEMENTS',
  STATEMENTS_STATEMENTS_TO_PULL = 'STATEMENTS_STATEMENTS_TO_PULL',
  STATEMENTS_STATEMENT_STATUS = 'STATEMENTS_STATEMENT_STATUS',
  PAYMENTS = 'PAYMENTS',
  PAYMENTS_ENTER_PAYMENTS = 'PAYMENTS_ENTER_PAYMENTS',
  PAYMENTS_ADJUST_ACCOUNTS = 'PAYMENTS_ADJUST_ACCOUNTS',
  BILLING_REPORTS = 'BILLING_REPORTS',
  DASHBOARD = 'DASHBOARD',
  COMPANIES = 'COMPANIES',
  CLAIMANTS = 'CLAIMANTS',
  CASES = 'CASES',
  SIDES = 'SIDES',
  SIDES_CONNECTORS = 'SIDES_CONNECTORS',
  SIDES_SEARCH = 'SIDES_SEARCH',
  BENEFIT_CHARGES = 'BENEFIT_CHARGES',
  PROTESTS = 'PROTESTS',
  STATEMENTS_OF_ACCOUNT = 'STATEMENTS_OF_ACCOUNT',
  RATE_NOTICES = 'RATE_NOTICES',
  DOCUMENTS = 'DOCUMENTS',
  ACTIVITIES = 'ACTIVITIES',
  ACTIVITIES_BENEFIT_CHARGES = 'ACTIVITIES_BENEFIT_CHARGES',
  ACTIVITIES_PARTNER_PROGRAM_MONTHLY_EMAIL = 'ACTIVITIES_PARTNER_PROGRAM_MONTHLY_EMAIL',
  ACTIVITIES_RATE_NOTICES = 'ACTIVITIES_RATE_NOTICES',
  ACTIVITIES_MISSING_RATE_NOTICES = 'ACTIVITIES_MISSING_RATE_NOTICES',
  ACTIVITIES_EMAIL_NOTIFICATION = 'ACTIVITIES_EMAIL_NOTIFICATION',
  ACTIVITIES_MA_RATE_NOTICES = 'ACTIVITIES_MA_RATE_NOTICES',
  ACTIVITIES_MAILING_LABELS = 'ACTIVITIES_MAILING_LABELS',
  REPORTS = 'REPORTS',
  REPORTS_UI_ACTIVITY_REPORT = 'REPORTS_UI_ACTIVITY_REPORT',
  REPORTS_RATE_NOTICES = 'REPORTS_RATE_NOTICES',
  REPORTS_BENEFIT_CHARGES = 'REPORTS_BENEFIT_CHARGES',
  REPORTS_PARTNER_PROGRAMS = 'REPORTS_PARTNER_PROGRAMS',
  REPORTS_ANNUAL_PAGES = 'REPORTS_ANNUAL_PAGES',
  BILLING = 'BILLING',
  ANALYTICS = 'ANALYTICS',
  ANALYTICS_ANALYST_PERFORMANCE = 'ANALYTICS_ANALYST_PERFORMANCE',
  SETTINGS = 'SETTINGS',
  SETTINGS_DATA = 'SETTINGS_DATA',
  SETTINGS_DATA_STATES = 'SETTINGS_DATA_STATES',
  SETTINGS_DATA_REASON_CODES = 'SETTINGS_DATA_REASON_CODES',
  SETTINGS_DATA_HEARINGS = 'SETTINGS_DATA_HEARINGS',
  SETTINGS_DATA_MANAGED_RULES = 'SETTINGS_DATA_MANAGED_RULES',
  SETTINGS_INTERNAL_USERS = 'SETTINGS_INTERNAL_USERS',
  SETTINGS_ANALYSTS_ASSIGNED = 'SETTINGS_ANALYSTS_ASSIGNED',
  SETTINGS_PARTNER_PROGRAMS = 'SETTINGS_PARTNER_PROGRAMS',
  SETTINGS_AUTHORIZE_ACCESS = 'SETTINGS_AUTHORIZE_ACCESS',
  SETTINGS_SECURITY = 'SETTINGS_SECURITY',
  TOOLS = 'TOOLS',
  TOOLS_PLEXTERA = 'TOOLS_PLEXTERA',
  TOOLS_FAX_CENTER = 'TOOLS_FAX_CENTER',
  TOOLS_LETTER_TEMPLATES = 'TOOLS_LETTER_TEMPLATES',
  HELP = 'HELP',
  ABOUT = 'ABOUT',
}

const getMenuKey = (type: MenuType): string => {
  switch (type) {
    case MenuType.CLIENTS:
    case MenuType.COMPANIES:
      return 'companies';
    case MenuType.CLIENT_DOCUMENTS:
      return 'clientDocuments';
    case MenuType.CLIENT_REPORTS:
      return 'clientReports';
    case MenuType.CONTRACTS_AND_RENEWALS:
      return 'contractsAndRenewals';
    case MenuType.INVOICES:
      return 'invoices';
    case MenuType.INVOICES_PROCESS_INVOICES:
      return 'invoicesProcessInvoices';
    case MenuType.INVOICES_INVOICES_TO_PULL:
      return 'invoicesInvoicesToPull';
    case MenuType.INVOICES_CREDIT_INVOICES:
      return 'invoicesCreditInvoices';
    case MenuType.INVOICES_INVOICE_STATUS:
      return 'invoicesInvoiceStatus';
    case MenuType.STATEMENTS:
      return 'statements';
    case MenuType.STATEMENTS_PROCESS_STATEMENTS:
      return 'statementsProcessStatements';
    case MenuType.STATEMENTS_STATEMENTS_TO_PULL:
      return 'statementsStatementsToPull';
    case MenuType.STATEMENTS_STATEMENT_STATUS:
      return 'statementsStatementStatus';
    case MenuType.PAYMENTS:
      return 'payments';
    case MenuType.PAYMENTS_ENTER_PAYMENTS:
      return 'paymentsEnterPayments';
    case MenuType.PAYMENTS_ADJUST_ACCOUNTS:
      return 'paymentsAdjustAccounts';
    case MenuType.BILLING_REPORTS:
      return 'billingReports';
    case MenuType.DASHBOARD:
      return 'dashboard';
    case MenuType.CONTACTS:
    case MenuType.PERSONNEL:
      return 'contacts';
    case MenuType.CLAIMANTS:
      return 'claimants';
    case MenuType.CASES:
      return 'cases';
    case MenuType.SIDES:
      return 'sides';
    case MenuType.SIDES_CONNECTORS:
      return 'sidesConnectors';
    case MenuType.SIDES_SEARCH:
      return 'sidesSearch';
    case MenuType.BENEFIT_CHARGES:
      return 'benefitCharges';
    case MenuType.PROTESTS:
      return 'protests';
    case MenuType.STATEMENTS_OF_ACCOUNT:
      return 'statementsOfAccount';
    case MenuType.RATE_NOTICES:
      return 'rateNotices';
    case MenuType.DOCUMENTS:
      return 'documents';
    case MenuType.ACTIVITIES:
      return 'activities';
    case MenuType.ACTIVITIES_BENEFIT_CHARGES:
      return 'activitiesBenefitCharges';
    case MenuType.ACTIVITIES_PARTNER_PROGRAM_MONTHLY_EMAIL:
      return 'activitiesPartnerProgramMonthlyEmail';
    case MenuType.ACTIVITIES_RATE_NOTICES:
      return 'activitiesRateNotices';
    case MenuType.ACTIVITIES_MISSING_RATE_NOTICES:
      return 'activitiesMissingRateNotices';
    case MenuType.ACTIVITIES_EMAIL_NOTIFICATION:
      return 'activitiesEmailNotification';
    case MenuType.ACTIVITIES_MA_RATE_NOTICES:
      return 'activitiesMaRateNotices';
    case MenuType.ACTIVITIES_MAILING_LABELS:
      return 'activitiesMailingLabels';
    case MenuType.REPORTS:
      return 'reports';
    case MenuType.REPORTS_UI_ACTIVITY_REPORT:
      return 'reportsUiActivityReport';
    case MenuType.REPORTS_RATE_NOTICES:
      return 'reportsRateNotices';
    case MenuType.REPORTS_BENEFIT_CHARGES:
      return 'reportsBenefitCharges';
    case MenuType.REPORTS_PARTNER_PROGRAMS:
      return 'reportsPartnerPrograms';
    case MenuType.REPORTS_ANNUAL_PAGES:
      return 'reportsAnnualPages';
    case MenuType.BILLING:
      return 'billing';
    case MenuType.ANALYTICS:
      return 'analytics';
    case MenuType.ANALYTICS_ANALYST_PERFORMANCE:
      return 'analyticsAnalystPerformance';
    case MenuType.SETTINGS:
      return 'settings';
    case MenuType.SETTINGS_DATA:
      return 'settingsData';
    case MenuType.SETTINGS_DATA_STATES:
      return 'settingsDataStates';
    case MenuType.SETTINGS_DATA_REASON_CODES:
      return 'settingsDataReasonCodes';
    case MenuType.SETTINGS_DATA_HEARINGS:
      return 'settingsDataHearings';
    case MenuType.SETTINGS_DATA_MANAGED_RULES:
      return 'settingsDataManagedRules';
    case MenuType.SETTINGS_INTERNAL_USERS:
      return 'settingsInternalUsers';
    case MenuType.SETTINGS_ANALYSTS_ASSIGNED:
      return 'settingsAnalystsAssigned';
    case MenuType.SETTINGS_PARTNER_PROGRAMS:
      return 'settingsPartnerPrograms';
    case MenuType.SETTINGS_AUTHORIZE_ACCESS:
      return 'settingsAuthorizeAccess';
    case MenuType.TOOLS:
      return 'tools';
    case MenuType.TOOLS_PLEXTERA:
      return 'toolsPlextera';
    case MenuType.TOOLS_FAX_CENTER:
      return 'toolsFaxReport';
    case MenuType.TOOLS_LETTER_TEMPLATES:
      return 'toolsLetterTemplates';
    case MenuType.HELP:
      return 'help';
    case MenuType.ABOUT:
      return 'about';
    default:
      return '';
  }
};

const baseMenuItems: MenuItem[] = [
  {
    text: 'Companies',
    route: `${CM_BASE_PATH}/clients`,
    materialIcon: 'business_center',
    activeBy: [
      {
        path: `${CM_BASE_PATH}/clients`,
        afterPaths: [],
      },
      {
        path: `${CM_BASE_PATH}/client/`,
        afterPaths: [],
      },
    ],
    rootModule: RootModuleType.CM,
    type: MenuType.CLIENTS,
  },
  {
    text: 'Contacts',
    route: `${CM_BASE_PATH}/personnel`,
    materialIcon: 'supervisor_account',
    activeBy: [
      {
        path: `${CM_BASE_PATH}/personnel`,
        afterPaths: [],
      },
      {
        path: `${CM_BASE_PATH}/person`,
        afterPaths: [],
      },
    ],
    rootModule: RootModuleType.CM,
    type: MenuType.PERSONNEL,
  },
  {
    text: 'Client Documents',
    route: `${CM_BASE_PATH}/client-documents`,
    materialIcon: 'folder',
    activeBy: [
      {
        path: `${CM_BASE_PATH}/client-documents`,
        afterPaths: [], // any path
      },
    ],
    rootModule: RootModuleType.CM,
    type: MenuType.CLIENT_DOCUMENTS,
  },
  {
    text: 'Client Reports',
    route: `${CM_BASE_PATH}/client-reports`,
    materialIcon: 'assignment_ind',
    activeLinks: ['client-reports'],
    rootModule: RootModuleType.CM,
    type: MenuType.CLIENT_REPORTS,
  },
  {
    text: 'Contracts & Renewals',
    route: `${CM_BASE_PATH}/contract-and-renewals`,
    materialIcon: 'assignment_turned_in',
    activeLinks: ['contract-and-renewals'],
    rootModule: RootModuleType.CM,
    type: MenuType.CONTRACTS_AND_RENEWALS,
  },
  {
    text: 'Invoices',
    materialIcon: 'request_quote',
    activeLinks: ['invoices'],
    rootModule: RootModuleType.CM,
    type: MenuType.INVOICES,
    subMenu: [
      {
        text: 'Process Invoices',
        route: `${CM_BASE_PATH}/invoices/process-invoices`,
        materialIcon: 'request_quote',
        type: MenuType.INVOICES_PROCESS_INVOICES,
      },
      {
        text: 'Invoices to Pull',
        route: `${CM_BASE_PATH}/invoices/to-pull`,
        materialIcon: 'request_quote',
        type: MenuType.INVOICES_INVOICES_TO_PULL,
      },
      {
        text: 'Credit Invoices',
        route: `${CM_BASE_PATH}/invoices/credit`,
        materialIcon: 'request_quote',
        type: MenuType.INVOICES_CREDIT_INVOICES,
      },
      {
        text: 'Invoice Status',
        route: `${CM_BASE_PATH}/invoices/invoice-statuses`,
        materialIcon: 'request_quote',
        type: MenuType.INVOICES_INVOICE_STATUS,
      },
    ],
  },
  {
    text: 'Statements',
    materialIcon: 'attach_money',
    activeLinks: ['statements'],
    rootModule: RootModuleType.CM,
    type: MenuType.STATEMENTS,
    subMenu: [
      {
        text: 'Process Statements',
        route: `${CM_BASE_PATH}/statements/process-statements`,
        materialIcon: 'attach_money',
        type: MenuType.STATEMENTS_PROCESS_STATEMENTS,
      },
      {
        text: 'Statements to Pull',
        route: `${CM_BASE_PATH}/statements/to-pull`,
        materialIcon: 'attach_money',
        type: MenuType.STATEMENTS_STATEMENTS_TO_PULL,
      },
      {
        text: 'Statement Status',
        route: `${CM_BASE_PATH}/statements/statement-statuses`,
        materialIcon: 'attach_money',
        type: MenuType.STATEMENTS_STATEMENT_STATUS,
      },
    ],
  },
  {
    text: 'Payments',
    materialIcon: 'payment',
    activeLinks: ['payments', 'adjustments'],
    rootModule: RootModuleType.CM,
    type: MenuType.PAYMENTS,
    subMenu: [
      {
        text: 'Enter Payments',
        route: `${CM_BASE_PATH}/payments`,
        materialIcon: 'payment',
        activeLinks: ['payments'],
        type: MenuType.PAYMENTS_ENTER_PAYMENTS,
      },
      {
        text: 'Adjust Accounts',
        route: `${CM_BASE_PATH}/adjustments`,
        materialIcon: 'payment',
        activeLinks: ['adjustments'],
        type: MenuType.PAYMENTS_ADJUST_ACCOUNTS,
      },
    ],
  },
  {
    text: 'Billing Reports',
    route: `${CM_BASE_PATH}/billing-reports`,
    materialIcon: 'assignment_turned_in',
    activeLinks: ['billing-reports'],
    rootModule: RootModuleType.CM,
    type: MenuType.BILLING_REPORTS,
  },
  // CMS
  {
    text: 'dashboard',
    route: `${CMS_BASE_PATH}`,
    materialIcon: 'equalizer',
    activeBy: [
      {
        path: `${CMS_BASE_PATH}`,
        afterPaths: ['', 'actionitems'],
      },
    ],
    rootModule: RootModuleType.CMS,
    type: MenuType.DASHBOARD,
  },
  {
    text: 'Companies',
    route: `${CMS_BASE_PATH}/companies`,
    materialIcon: 'group',
    activeBy: [
      {
        path: `${CMS_BASE_PATH}/companies`,
        afterPaths: [],
      },
      {
        path: `${CMS_BASE_PATH}/company/`,
        afterPaths: [],
      },
    ],
    activeLinks: [`companies`],
    rootModule: RootModuleType.CMS,
    type: MenuType.COMPANIES,
  },
  {
    text: 'Contacts',
    route: `${CMS_BASE_PATH}/contacts`,
    materialIcon: 'supervisor_account',
    activeBy: [
      {
        path: `${CMS_BASE_PATH}/contacts`,
        afterPaths: [],
      },
      {
        path: `${CMS_BASE_PATH}/contact`,
        afterPaths: [],
      },
    ],
    rootModule: RootModuleType.CMS,
    type: MenuType.CONTACTS,
  },
  {
    text: 'Claimants',
    route: `${CMS_BASE_PATH}/claimants`,
    materialIcon: 'person_search',
    activeBy: [
      {
        path: `${CMS_BASE_PATH}/claimants`,
        afterPaths: [],
      },
    ],
    rootModule: RootModuleType.CMS,
    type: MenuType.CLAIMANTS,
  },
  {
    text: 'Cases',
    route: `${CMS_BASE_PATH}/cases`,
    materialIcon: 'sms_failed',
    activeLinks: [`cases`],
    rootModule: RootModuleType.CMS,
    type: MenuType.CASES,
  },
  {
    text: 'SIDES',
    materialIcon: 'cloud',
    activeLinks: ['sides'],
    rootModule: RootModuleType.CMS,
    type: MenuType.SIDES,
    subMenu: [
      {
        text: 'Connectors',
        route: `${CMS_BASE_PATH}/sides/connectors`,
        materialIcon: 'cast_connected',
        type: MenuType.SIDES_CONNECTORS,
      },
      {
        text: 'Search',
        route: `${CMS_BASE_PATH}/sides/search`,
        materialIcon: 'search',
        type: MenuType.SIDES_SEARCH,
      },
    ],
  },
  {
    text: 'Benefit Charges',
    route: `${CMS_BASE_PATH}/benefitcharges`,
    materialIcon: 'verified_user',
    activeLinks: ['benefitcharges'],
    rootModule: RootModuleType.CMS,
    type: MenuType.BENEFIT_CHARGES,
  },
  {
    text: 'Protests',
    route: `${CMS_BASE_PATH}/protests`,
    materialIcon: 'library_books',
    activeBy: [
      {
        path: `${CMS_BASE_PATH}/protests`,
        afterPaths: [], // any path
      },
    ],
    rootModule: RootModuleType.CMS,
    type: MenuType.PROTESTS,
  },
  {
    text: 'Statements of Account',
    route: `${CMS_BASE_PATH}/statements-of-account`,
    materialIcon: 'description',
    activeLinks: ['statements-of-account'],
    rootModule: RootModuleType.CMS,
    type: MenuType.STATEMENTS_OF_ACCOUNT,
  },
  {
    text: 'Rate Notices',
    route: `${CMS_BASE_PATH}/rate-notices`,
    materialIcon: 'event_note',
    activeBy: [
      {
        path: `${CMS_BASE_PATH}/rate-notices`,
        afterPaths: [],
      },
    ],
    rootModule: RootModuleType.CMS,
    type: MenuType.RATE_NOTICES,
  },
  {
    text: 'Documents',
    route: `${CMS_BASE_PATH}/documents`,
    materialIcon: 'folder',
    activeBy: [
      {
        path: `${CMS_BASE_PATH}/documents`,
        afterPaths: [], // any path
      },
    ],
    rootModule: RootModuleType.CMS,
    type: MenuType.DOCUMENTS,
  },
  {
    text: 'Activities',
    materialIcon: 'view_list',
    activeLinks: ['activities'],
    rootModule: RootModuleType.CMS,
    type: MenuType.ACTIVITIES,
    subMenu: [
      {
        text: 'Benefit Charges',
        materialIcon: 'widgets',
        cssClass: 'text-nowrap',
        subMenu: [
          {
            text: 'Partner Program Monthly Email',
            route: `${CMS_BASE_PATH}/activities/partner-program-monthly-report`,
            materialIcon: 'import_export',
            type: MenuType.ACTIVITIES_PARTNER_PROGRAM_MONTHLY_EMAIL,
          },
        ],
        type: MenuType.ACTIVITIES_BENEFIT_CHARGES,
      },
      {
        text: 'Rate Notices',
        materialIcon: 'event_note',
        type: MenuType.ACTIVITIES_RATE_NOTICES,
        subMenu: [
          {
            text: 'Missing Rate Notices',
            route: `${CMS_BASE_PATH}/activities/missing-rn`,
            materialIcon: 'notifications',
            type: MenuType.ACTIVITIES_MISSING_RATE_NOTICES,
          },
          {
            text: 'Email Notification',
            route: `${CMS_BASE_PATH}/activities/email-notification`,
            materialIcon: 'email',
            type: MenuType.ACTIVITIES_EMAIL_NOTIFICATION,
          },
          {
            text: 'MA Rate Notices',
            route: `${CMS_BASE_PATH}/activities/ma-email-notification`,
            materialIcon: 'event_note',
            type: MenuType.ACTIVITIES_MA_RATE_NOTICES,
          },
        ],
      },
      {
        text: 'Mailing Labels',
        route: `${CMS_BASE_PATH}/activities/mailing-labels`,
        materialIcon: 'email',
        type: MenuType.ACTIVITIES_MAILING_LABELS,
      },
    ],
  },
  {
    text: 'Reports',
    materialIcon: 'assignment_turned_in',
    activeLinks: ['reports'],
    rootModule: RootModuleType.CMS,
    type: MenuType.REPORTS,
    subMenu: [
      {
        text: 'UI Activity Report',
        route: `${CMS_BASE_PATH}/reports/activity-report`,
        materialIcon: 'event_note',
        type: MenuType.REPORTS_UI_ACTIVITY_REPORT,
      },
      {
        text: 'Rate Notices',
        route: `${CMS_BASE_PATH}/reports/rate-notices`,
        materialIcon: 'event_note',
        type: MenuType.REPORTS_RATE_NOTICES,
      },
      {
        text: 'Benefit Charges',
        route: `${CMS_BASE_PATH}/reports/benefit-charges`,
        materialIcon: 'event_note',
        type: MenuType.REPORTS_BENEFIT_CHARGES,
      },
      {
        text: 'Partner Programs',
        route: `${CMS_BASE_PATH}/reports/partner-programs`,
        materialIcon: 'event_note',
        type: MenuType.REPORTS_PARTNER_PROGRAMS,
      },
      {
        text: 'Annual Pages',
        route: `${CMS_BASE_PATH}/reports/annual-pages`,
        materialIcon: 'event_note',
        type: MenuType.REPORTS_ANNUAL_PAGES,
      },
    ],
  },
  {
    text: 'Billing',
    route: `${CMS_BASE_PATH}/billing`,
    materialIcon: 'request_quote',
    activeLinks: ['billing'],
    rootModule: RootModuleType.CMS,
    type: MenuType.BILLING,
  },
  {
    text: 'Analytics',
    materialIcon: 'assignment_turned_in',
    subMenu: [
      {
        text: 'Analyst Performance',
        route: `${CMS_BASE_PATH}/analytics/analyst-performance`,
        materialIcon: 'event_note',
        type: MenuType.ANALYTICS_ANALYST_PERFORMANCE,
      },
    ],
    activeLinks: ['analytics'],
    rootModule: RootModuleType.CMS,
    type: MenuType.ANALYTICS,
  },
  {
    text: 'Settings',
    materialIcon: 'settings',
    activeBy: [
      {
        path: `${CMS_BASE_PATH}`,
        afterPaths: ['users', 'analysts', 'partner-programs', 'security'],
        doesNotInclude: 'reports', // after path does not include this part
      },
      {
        path: `states`,
        afterPaths: [],
      },
      {
        path: `reason-codes`,
        afterPaths: [],
      },
      {
        path: `hearings`,
        afterPaths: ['affiliates', 'location'],
      },
      {
        path: `managed-rules`,
        afterPaths: [],
      },
    ],
    rootModule: RootModuleType.CMS,
    type: MenuType.SETTINGS,
    subMenu: [
      {
        text: 'Internal Users',
        route: `${CMS_BASE_PATH}/users`,
        materialIcon: 'group',
        type: MenuType.SETTINGS_INTERNAL_USERS,
      },
      {
        text: 'Analysts Assigned',
        route: `${CMS_BASE_PATH}/analysts`,
        materialIcon: 'account_circle',
        type: MenuType.SETTINGS_ANALYSTS_ASSIGNED,
      },
      {
        text: 'Partner Programs',
        route: `${CMS_BASE_PATH}/partner-programs`,
        materialIcon: 'work',
        type: MenuType.SETTINGS_PARTNER_PROGRAMS,
      },
      {
        text: 'Authorize Access',
        route: `${CMS_BASE_PATH}/auth-access`,
        materialIcon: 'security',
        type: MenuType.SETTINGS_AUTHORIZE_ACCESS,
      },
      {
        text: 'Data',
        materialIcon: 'assignment',
        type: MenuType.SETTINGS_DATA,
        subMenu: [
          {
            text: 'States',
            route: `${CMS_BASE_PATH}/states`,
            materialIcon: 'flag',
            type: MenuType.SETTINGS_DATA_STATES,
          },
          {
            text: 'Reason Codes',
            route: `${CMS_BASE_PATH}/reason-codes/separationcodemapping`,
            materialIcon: 'label',
            type: MenuType.SETTINGS_DATA_REASON_CODES,
          },
          {
            text: 'Hearings',
            route: `${CMS_BASE_PATH}/hearings/affiliates`,
            materialIcon: 'work',
            type: MenuType.SETTINGS_DATA_HEARINGS,
          },
          {
            text: 'Managed Rules',
            route: `${CMS_BASE_PATH}/managed-rules`,
            materialIcon: 'rule',
            type: MenuType.SETTINGS_DATA_MANAGED_RULES,
          },
        ],
      },
      {
        text: 'Security',
        route: `${CMS_BASE_PATH}/security`,
        materialIcon: 'key',
        type: MenuType.SETTINGS_SECURITY,
      },
    ],
  },
  {
    text: 'Tools',
    materialIcon: 'work',
    rootModule: RootModuleType.CMS,
    type: MenuType.TOOLS,
    activeLinks: ['fax-center', 'letter-templates'],
    subMenu: [
      {
        text: 'Plextera',
        imgIcon: 'assets/img/plextera.svg',
        imgIconHover: 'assets/img/plextera_hover.svg',
        type: MenuType.TOOLS_PLEXTERA,
        callback: MenuCallback.PLEXTERA_LINK,
      },
      {
        text: 'Fax Center',
        materialIcon: 'fax',
        type: MenuType.TOOLS_FAX_CENTER,
        activeLinks: [`fax-center`],
        route: `${CMS_BASE_PATH}/fax-center`,
      },
      {
        text: 'Letter Templates',
        route: `${CMS_BASE_PATH}/tools/letter-templates`,
        materialIcon: 'description',
        activeLinks: [`letter-templates`],
        type: MenuType.TOOLS_LETTER_TEMPLATES,
      },
    ],
  },
  {
    text: 'Help',
    materialIcon: 'live_help',
    route: `${CMS_BASE_PATH}/articles`,
    activeBy: [
      {
        path: `${CMS_BASE_PATH}/articles`,
        afterPaths: [], // any path
      },
    ],
    rootModule: RootModuleType.CMS,
    type: MenuType.HELP,
  },
  {
    text: 'About',
    route: `${CMS_BASE_PATH}/about`,
    materialIcon: 'info_outline',
    activeBy: [
      {
        path: `${CMS_BASE_PATH}/about`,
        afterPaths: [],
      },
    ],
    rootModule: RootModuleType.CMS,
    type: MenuType.ABOUT,
  },
];

export function getMenuItems(accessRulesService?: any): MenuItem[] {
  if (!accessRulesService) {
    return baseMenuItems;
  }

  return baseMenuItems.map((item) => ({
    ...item,
    text: accessRulesService.getCustomMenuText(getMenuKey(item.type), item.text),
    subMenu: item.subMenu
      ? item.subMenu.map((subItem) => ({
          ...subItem,
          text: accessRulesService.getCustomMenuText(getMenuKey(subItem.type), subItem.text),
          subMenu: subItem.subMenu
            ? subItem.subMenu.map((subSubItem) => ({
                ...subSubItem,
                text: accessRulesService.getCustomMenuText(
                  getMenuKey(subSubItem.type),
                  subSubItem.text,
                ),
              }))
            : undefined,
        }))
      : undefined,
  }));
}

export const menuItems: MenuItem[] = baseMenuItems;
